export const clientPhiPatterns = [
  /\b\d{3}-\d{2}-\d{4}\b/i,
  /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/i,
  /\b(?:\+?1[\s.-]?)?(?:\(?\d{3}\)?[\s.-]?)\d{3}[\s.-]?\d{4}\b/i,
  /\b(?:dob|date of birth|birth date|born)\b.{0,40}(?:\b\d{1,2}[/-]\d{1,2}[/-]\d{2,4}\b|\b(?:jan(?:uary)?|feb(?:ruary)?|mar(?:ch)?|apr(?:il)?|may|jun(?:e)?|jul(?:y)?|aug(?:ust)?|sep(?:tember)?|sept|oct(?:ober)?|nov(?:ember)?|dec(?:ember)?)\s+\d{1,2},?\s+\d{2,4}\b)/i,
  /\b(?:admission date|discharge date|service date|date of service|visit date|fill date|pickup date|surgery date|appointment date)\b.{0,40}\b\d{1,2}[/-]\d{1,2}[/-]\d{2,4}\b/i,
  /\b[1-9][A-HJ-NP-RT-Y][A-HJ-NP-RT-Y0-9][\s-]?\d[A-HJ-NP-RT-Y][\s-]?[A-HJ-NP-RT-Y0-9]\d[A-HJ-NP-RT-Y]{2}\d{2}\b/i,
  /\b(?:mrn|medical record(?: number| #)?|record number)\b.{0,20}\b[A-Z0-9-]{5,}\b/i,
  /\b(?:member id|member number|beneficiary id|subscriber id|account number)\b.{0,20}\b[A-Z0-9-]{5,}\b/i,
  /\b\d{1,6}\s+[A-Z0-9][A-Z0-9 .'-]{1,45}\s+(?:street|st|avenue|ave|road|rd|drive|dr|lane|ln|boulevard|blvd|court|ct|circle|cir|way|place|pl)\b/i,
  /\b(?:zip|zip code|zipcode|postal code)\b.{0,12}\b\d{5}(?:-\d{4})?\b/i,
  /\b(?:patient name|beneficiary name|member name|(?:patient|pt|beneficiary|member)\s+named)\s*(?:is|:)?\s*[A-Za-z][A-Za-z'-]+(?:\s+[A-Za-z][A-Za-z'-]+){1,2}\b/i,
  /\b(?:(?:age|aged)\s*(?:9\d|1\d{2})|(?:9\d|1\d{2})[- ]year[- ]old)\b/i,
];

export function looksLikePhiClient(text) {
  const normalized = String(text || '').replace(/glp1demo@cms\.hhs\.gov/gi, '');
  return clientPhiPatterns.some((pattern) => pattern.test(normalized));
}
